<script setup lang="ts">
import { onLaunch, onShow, onHide } from '@dcloudio/uni-app'
import 'abortcontroller-polyfill/dist/abortcontroller-polyfill-only'
import VConsole from 'vconsole'

onLaunch(() => {
  // console.log('App Launch')
  // #ifdef H5

  // #ifdef H5

  if (import.meta.env.VITE_SHOW_VCONSOLE === 'true') {
    const vConsole = new VConsole({
      maxLogNumber: 100,
      theme: 'dark',
    })
  }

  // 检查 sessionStorage 中是否有启动标记
  if (!sessionStorage.getItem('app_started')) {
    // 冷启动：清除登录信息
    uni.removeStorageSync('user')
    // 设置标记，避免重复清除
    sessionStorage.setItem('app_started', 'true')
    // 注意：这里不能直接跳转，因为可能还没加载首页组件
    // 可以通过全局事件或 Vuex 状态来控制首页跳转
    // 下面是一种简单方式：将需要跳转的信息存入 globalData
    getApp().globalData.needLogin = true
  }
})
onShow(() => {
  // console.log('App Show')
})
onHide(() => {
  // console.log('App Hide')
})
</script>

<style lang="scss">
@use '/src/style/ipad/index.scss' as *;
@import '/src/style/index';

// 单行省略，优先使用 unocss: text-ellipsis
.ellipsis {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

// 两行省略
.ellipsis-2 {
  display: -webkit-box;
  overflow: hidden;
  text-overflow: ellipsis;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}

// 三行省略
.ellipsis-3 {
  display: -webkit-box;
  overflow: hidden;
  text-overflow: ellipsis;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
}
</style>
